import { processSecurePath } from '~/utils/utils';

/**
 * Section Hero
 * @category Functional Component
 * @summary Displays a section hero.
 * @prop {jsx} children - Child nodes to display.
 * @prop {Object} pageInfo - Page info section, should contain name, fieldSubhead and a fieldImageSection object.
 * @prop {String} additionalClasses - Additional classes for the section.
 * @return {Node} React node containing the section hero.
 */

const SectionHero = props => {
  const { pageInfo, children, additionalClasses } = props;

  return (
    <>
      <section className='section-hero'>
        { pageInfo.img &&
          <picture>
            <source media='(max-width: 1068px)' srcSet={ processSecurePath(pageInfo.img.sm.url) } />
            <img
              src={ processSecurePath(pageInfo.img.lg.url) }
              alt={ pageInfo.img.alt }
              className='img-full'
            />
          </picture>
         }
        { pageInfo.heading &&
          <div className={`section-hero__desc section-hero__desc--bottom ${ additionalClasses }`}>
            <div>
              <h1>{ pageInfo.heading }</h1>
              <h2>{ pageInfo.subheading }</h2>
            </div>
            { children }
          </div>
        }
      </section>
    </>
  );
}

export default SectionHero;
